import NestedModals from './nested-modals';
import LogoutConfirmationModal from './LogoutConfirmationModal';
import ProfileModal from './ProfileModal';

export default {
  NestedModals,
  LogoutConfirmationModal,
  ProfileModal,
};
